import {Grid, Section, Stack} from '@primer/react-brand/esm'

import {hpcAttrs} from '@github-ui/hpc'
import {ContentfulFeatureComparisonTable} from '@github-ui/swp-core/components/contentful/ContentfulFeatureComparisonTable'
import {ContentfulHero} from '@github-ui/swp-core/components/contentful/ContentfulHero'
import {ContentfulInlineFootnotesList} from '@github-ui/swp-core/components/contentful/ContentfulInlineFootnotesList'
import {ContentfulLogoSuite} from '@github-ui/swp-core/components/contentful/ContentfulLogoSuite'
import {ContentfulPricingOptions} from '@github-ui/swp-core/components/contentful/ContentfulPricingOptions'
import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'

import {BrandPageContent} from '../../brand/components/BrandPage'

import {CardsSection} from './_sections/CardsSection/CardsSection'
import {CustomerStorySection} from './_sections/CustomerStorySection/CustomerStorySection'
import {pricingComparisonView, pricingPage} from './content'
import styles from './Pricing.module.css'

export function PricingIndex() {
  return (
    <BrandPageContent definition={pricingPage} className={styles.Page} withFootnotes>
      {({hero, pricingOptions, addOns, customerEvidence, comparisonTable, resources}) => (
        <>
          {hero && <ContentfulHero {...hpcAttrs()} component={hero} variant="gridline" />}

          {pricingOptions && (
            <Section
              id={pricingOptions.htmlId}
              variant="gridline"
              fullWidth
              paddingBlockStart="none"
              paddingBlockEnd="none"
            >
              <Grid enableGutters={false}>
                <Grid.Column span={12}>
                  <ContentfulPricingOptions component={pricingOptions.pricing} />
                </Grid.Column>
              </Grid>
            </Section>
          )}

          {addOns && <CardsSection content={addOns} />}

          {customerEvidence && (
            <Section id={customerEvidence.htmlId} variant="gridline" fullWidth>
              <Section as="div" variant="gridline" fullWidth paddingBlockStart="none" paddingBlockEnd="none">
                {customerEvidence.logos && (
                  <ContentfulLogoSuite
                    component={customerEvidence.logos}
                    variant="gridline-expressive"
                    marquee
                    marqueeSpeed="slow"
                  />
                )}

                {customerEvidence.customerStory && <CustomerStorySection content={customerEvidence.customerStory} />}
              </Section>
            </Section>
          )}

          {comparisonTable && (
            <Section
              id={comparisonTable.htmlId}
              variant="gridline"
              fullWidth
              paddingBlockStart={comparisonTable.intro ? undefined : 'none'}
              paddingBlockEnd="none"
            >
              <Grid enableGutters={false}>
                <Grid.Column span={12}>
                  <Stack padding="none" gap={{narrow: 48, regular: 64}}>
                    {comparisonTable.intro && <ContentfulSectionIntro component={comparisonTable.intro} />}

                    <ContentfulFeatureComparisonTable component={comparisonTable.table} view={pricingComparisonView} />
                  </Stack>
                </Grid.Column>
              </Grid>
            </Section>
          )}

          {resources && <CardsSection content={resources} paddingBlockEnd="normal" />}

          <ContentfulInlineFootnotesList />
        </>
      )}
    </BrandPageContent>
  )
}
